export default {
  contactHeroTitle: "Contattaci",
  contactHeroSubtitle: "Siamo qui per aiutarti a navigare nel complesso mondo dello sviluppo farmaceutico. Che tu abbia bisogno di produzione API, sviluppo di formulazioni o supporto normativo, il nostro team è pronto ad assisterti.",
  contactGetInTouchTitle: "Mettersi in contatto",
  contactOurAddress: "Il nostro indirizzo",
  contactMainAddress: "67, Bazullah Road,<br />Partha Sarathy Puram,<br />T Nagar, Chennai – 600017<br />Tamil Nadu, India",
  contactOtherAddresses: "Altri indirizzi",
  contactAddressBangalore: "Phoenix Mall of Asia – Torre 2,<br />Livello 6, Unità 602, Yelahanka Hobli,<br />Byatarayanapura, Bangalore – 560092,<br />Karnataka, India",
  contactAddressMumbai: "409, Complesso Bezzola,<br />Sion Trombay Road,<br />Chembur, Mumbai - 400 071<br />Maharashtra, India.",
  contactAddressSwitzerland: "Bahnhof-Park 4,<br />Baar 6340,<br />Svizzera",
  contactEmail: "E-mail",
  contactFormTitle: "Inviaci un messaggio",
  contactFormNameLabel: "Nome completo *",
  contactFormNamePlaceholder: "Inserisci il tuo nome completo",
  contactFormEmailLabel: "Indirizzo e-mail *",
  contactFormEmailPlaceholder: "Inserisci il tuo indirizzo e-mail",
  contactFormPhoneLabel: "Numero di telefono",
  contactFormPhonePlaceholder: "Inserisci il tuo numero di telefono",
  contactFormCompanyLabel: "Azienda",
  contactFormCompanyPlaceholder: "Inserisci il nome della tua azienda",
  contactFormMessageLabel: "Messaggio *",
  contactFormMessagePlaceholder: "Raccontaci del tuo progetto o della tua richiesta...",
  contactFormCharacters: "caratteri",
  contactFormSubmitButton: "Mettersi in contatto",
  contactFormSubmitting: "Invio...",
  contactFormRecaptchaRequired: "Si prega di completare il reCAPTCHA",
  contactFormSuccess: "Grazie! Il tuo messaggio è stato inviato con successo. Ti risponderemo entro 24 ore.",
  contactFormError: "Spiacenti, si è verificato un errore durante l'invio del messaggio. Riprova o contattaci direttamente.",
};

